import {
  PortainerPair,
  WorkflowsCreatePayloadArtifactParallelConfig,
  WorkflowsCreatePayloadFile,
} from '@api/types.gen';

import {
  StaggerConfig,
  StaggerParallelOption,
  UpdateFailureAction,
} from '@/react/edge/edge-stacks/components/StaggerFieldset.types';

import { Values as EnvVarValues } from '@@/form-components/EnvironmentVariablesFieldset/types';

import { ArtifactFile } from './types';

/**
 * Field mappings shared by the create and update payload builders, so both
 * describe an artifact to the API the same way.
 */
export function toFilesPayload(
  files: Array<ArtifactFile>
): Array<WorkflowsCreatePayloadFile> {
  return files.map((file) => ({
    sourceId: file.sourceId,
    path: file.path,
    ref: file.ref,
  }));
}

export function toEnvVarsPayload(envVars: EnvVarValues): Array<PortainerPair> {
  return envVars
    .filter((envVar) => !envVar.needsDeletion)
    .map((envVar) => ({ name: envVar.name, value: envVar.value ?? '' }));
}

/**
 * Maps a stagger config the user has switched to parallel. All-at-once is
 * expressed differently per endpoint, so callers handle it themselves.
 */
export function toParallelDeploymentConfig(
  config: StaggerConfig
): WorkflowsCreatePayloadArtifactParallelConfig {
  return {
    batchCount: config.DeviceNumber,
    batchIncrementBy:
      config.StaggerParallelOption === StaggerParallelOption.Incremental
        ? config.DeviceNumberIncrementBy
        : undefined,
    delay: config.UpdateDelay,
    timeout: config.Timeout,
    failureAction: toFailureAction(config.UpdateFailureAction),
  };
}

function toFailureAction(action: UpdateFailureAction | undefined) {
  if (action === UpdateFailureAction.Pause) {
    return 'pause';
  }

  if (action === UpdateFailureAction.Rollback) {
    return 'rollback';
  }

  return 'continue';
}
